<script>
import Drawer from './components/Drawer.svelte';
import Alerts from './components/Alerts.svelte';
</script>

<Drawer />
<Alerts />
<div class="container">
    <h1>404</h1>
    <h2>Looks like this page doesn't exist! &#128008;</h2>
</div>